
export enum CustomerProductItemOPEEnum {
  PutCustomerProductItemRegistryStatus = 'putCustomerProductItemRegistryStatus',      //SOLO DEVICE
  PutCustomerProductItem = 'putCustomerProductItem',          //IN COMUNE
  PutCustomerProductItemOnOSM = 'putCustomerProductItemOnOSM',    //IN COMUNE
  GetE015DefaultChargers = 'getE015DefaultChargers',          //DA TOGLIERE
  GetProductItemToken = 'getProductItemToken',                  //SOLO DEVICE
  GetCustomerProductItems = 'getCustomerProductItems',          //IN COMUNE
  GetCustomerProductItemAttributes = 'getCustomerProductItemAttributes',  //IN COMUNE
  DelCustomerProductItem = 'delCustomerProductItem',      //IN COMUNE
  ChangeProductItemOwner = 'changeProductItemOwner',      //IN COMUNE
  ChangeProductItemToken = 'changeProductItemToken',      //SOLO DEVICE
  DelCustomerProductItemChirpstack = 'delCustomerProductItemChirpstack',    //SOLO DEVICE
}
